export const isNewFeatureEnabled = () => {
    return process.env.REACT_APP_NEW_FEATURE_ENABLED === 'true'
}

export const isSelfHosted = () => {
    return process.env.REACT_APP_IS_SELF_HOSTED === 'true'
}
